/*
  GEN78 — ürün sayfası varyant seçicisi (akordiyon açılır liste)

  Neden var: tarayıcının kendi <select> açılır listesi masaüstünde tema ile
  uyumsuz görünüyordu (bkz. referanslar/ klasöründeki revize isteği görseli).
  Native <select> DOM'da kalıyor ama ekranda gizli; görünen arayüz bu dosyada
  yönetiliyor. Seçim yapıldığında select'e yazıp "change" olayı tetikleniyor —
  theme.js'teki ProductForm ve variantAvailability aynı olayı zaten dinliyor,
  yani fiyat/görsel/sepet düğmesi güncellemeleri değişmeden çalışmaya devam eder.

  Ayrıca her seçeneğin yanına stok ibaresi yazılıyor (mytheresa referansı):
  "Son ürün" (1 adet), "Sınırlı stok" (eşik ve altı), "Tükendi".
  İlk render Liquid'de yapılır; burada yalnızca seçim değiştikçe tazelenir.

  İki ayrı blok bu bileşeni kullanıyor:
  * prada_variant_selector (snippets/product-blocks.liquid) — varsayılan ürün
    şablonundaki beden seçici, .prada-variant-selector kapsayıcısı içinde
  * variant_picker (snippets/product-block-variant-picker.liquid) — hızlı
    görünüm ve diğer ürün şablonları, .product__variants-wrapper içinde
  Aynı stok kuralının Liquid karşılığı: snippets/gen78-variant-stock-label.liquid
*/
(function () {
  'use strict';

  var SELECTORS = {
    root: '[data-gen78-vselect]',
    trigger: '[data-gen78-vselect-trigger]',
    value: '[data-gen78-vselect-value]',
    panel: '[data-gen78-vselect-panel]',
    list: '.gen78-vselect__list',
    option: '[data-gen78-vselect-option]',
    stock: '[data-gen78-vselect-stock]',
    native: '.gen78-vselect__native',
    wrapper: '.product__variants-wrapper, .prada-variant-selector',
    stockJson: '[data-gen78-variant-stock]',
    optionSelect: 'select[data-index]',
    stickyChangeOption: '[data-change-option-trigger]'
  };

  var CLASSES = {
    open: 'is-open',
    selected: 'selected',
    soldOut: 'gen78-vselect__option--sold-out',
    emptyStock: 'is-empty'
  };

  var DEFAULT_THRESHOLD = 5;

  function all(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  /* ---------------------------------------------------------------- açma/kapama */

  function isOpen(root) {
    return root.classList.contains(CLASSES.open);
  }

  function open(root) {
    closeAll(root);
    root.classList.add(CLASSES.open);
    var trigger = root.querySelector(SELECTORS.trigger);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    // Seçili beden listenin görünmeyen kısmındaysa listeyi kaydır. scrollIntoView
    // yerine doğrudan scrollTop: sayfanın kendisi kaymasın. Açılma animasyonu
    // bitmeden liste yüksekliği 0 olduğu için ölçüm sonraya bırakılıyor.
    window.setTimeout(function () {
      var list = root.querySelector(SELECTORS.list);
      var selected = root.querySelector(SELECTORS.option + '.' + CLASSES.selected);
      if (!list || !selected) return;

      var offset = selected.getBoundingClientRect().top - list.getBoundingClientRect().top;
      if (offset < 0 || offset + selected.offsetHeight > list.clientHeight) {
        list.scrollTop += offset;
      }
    }, 300);
  }

  function close(root) {
    if (!isOpen(root)) return;
    root.classList.remove(CLASSES.open);
    var trigger = root.querySelector(SELECTORS.trigger);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    all(SELECTORS.root).forEach(function (root) {
      if (root !== except) close(root);
    });
  }

  /* ------------------------------------------------------------------- seçim */

  function nativeSelectOf(root) {
    return root.querySelector(SELECTORS.native);
  }

  function selectValue(root, button) {
    var native = nativeSelectOf(root);
    if (!native) return;

    var handle = button.getAttribute('data-value-handle');
    var options = native.options;
    var found = false;

    for (var i = 0; i < options.length; i++) {
      if (options[i].getAttribute('data-value-handle') === handle) {
        native.selectedIndex = i;
        found = true;
        break;
      }
    }

    if (!found) native.value = button.getAttribute('data-option-value');

    // theme.js'teki ProductForm/variantAvailability ve bizim bindWrapper'ımız
    // doğrudan select üzerinde dinliyor; bubbles yine de native davranışa uygun.
    native.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Görünen arayüzü native select'in gerçek değerine eşitler. Seçim buradan
  // yapılmamış olsa bile (sticky bar, tema editörü, dinamik seçenekler) doğru kalır.
  function syncFromNative(root) {
    var native = nativeSelectOf(root);
    if (!native) return;

    var value = native.value;
    var label = root.querySelector(SELECTORS.value);

    if (label) {
      // Prada seçicide ilk seçenek boş değerli bir yer tutucu ("BEDEN SEÇİN").
      // Seçili olan oysa değeri değil metnini göstermeliyiz.
      var display = value;

      if (!display) {
        var current = native.options[native.selectedIndex];
        display = current ? current.textContent.trim() : '';
      }

      label.textContent = display;
    }

    all(SELECTORS.option, root).forEach(function (button) {
      var isCurrent = button.getAttribute('data-option-value') === value;
      button.classList.toggle(CLASSES.selected, isCurrent);
      button.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
    });
  }

  /* -------------------------------------------------------------- stok ibareleri */

  function variantsOf(wrapper) {
    if (wrapper.gen78Variants !== undefined) return wrapper.gen78Variants;

    var script = wrapper.querySelector(SELECTORS.stockJson);
    var parsed = null;

    if (script) {
      try {
        parsed = JSON.parse(script.textContent);
      } catch (error) {
        parsed = null;
      }
    }

    wrapper.gen78Variants = parsed;
    return parsed;
  }

  // Her seçenek grubunda o an seçili değer (0 tabanlı seçenek sırasına göre).
  function currentSelection(wrapper) {
    var selection = [];

    all(SELECTORS.optionSelect, wrapper).forEach(function (select) {
      var match = /option(\d+)/.exec(select.getAttribute('data-index') || '');
      if (match) selection[parseInt(match[1], 10) - 1] = select.value;
    });

    return selection;
  }

  function labelFor(matches, root) {
    if (!matches.length) return '';

    var data = root.dataset;
    var available = matches.filter(function (variant) { return variant.available; });

    if (!available.length) return data.labelSoldOut || '';

    // Stok takibi kapalıysa adet bilgisi anlamsız — ibare yazma.
    if (available.some(function (variant) { return !variant.tracked; })) return '';

    var threshold = parseInt(data.lowStockThreshold, 10);
    if (!threshold || threshold < 1) threshold = DEFAULT_THRESHOLD;

    var quantity = available.reduce(function (total, variant) {
      return total + (parseInt(variant.qty, 10) || 0);
    }, 0);

    if (quantity === 1) return data.labelLastPiece || '';
    if (quantity > 0 && quantity <= threshold) return data.labelLowStock || '';
    return '';
  }

  function refreshWrapper(wrapper) {
    var variants = variantsOf(wrapper);
    if (!variants) return;

    var selection = currentSelection(wrapper);

    all(SELECTORS.root, wrapper).forEach(function (root) {
      var index = parseInt(root.getAttribute('data-option-position'), 10) - 1;
      if (isNaN(index) || index < 0) return;

      all(SELECTORS.option, root).forEach(function (button) {
        var value = button.getAttribute('data-option-value');

        // Önce diğer seçeneklerdeki güncel seçimle birlikte eşleşen varyantlar.
        var matches = variants.filter(function (variant) {
          if (variant.options[index] !== value) return false;

          for (var i = 0; i < variant.options.length; i++) {
            if (i === index) continue;
            if (selection[i] != null && variant.options[i] !== selection[i]) return false;
          }

          return true;
        });

        // Hiç kombinasyon yoksa (o beden bu renkte hiç üretilmemiş gibi)
        // sadece bu değere sahip tüm varyantlara bak.
        if (!matches.length) {
          matches = variants.filter(function (variant) {
            return variant.options[index] === value;
          });
        }

        var label = labelFor(matches, root);
        var target = button.querySelector(SELECTORS.stock);

        if (target) {
          target.textContent = label;
          target.classList.toggle(CLASSES.emptyStock, label === '');
        }

        var soldOut = matches.length > 0 && !matches.some(function (variant) {
          return variant.available;
        });
        button.classList.toggle(CLASSES.soldOut, soldOut);

        // Prada bloğu tükenen bedeni seçtirmiyor (native select'te de disabled).
        // Genel seçicide seçilebilir kalıyor: tema o durumda sepet düğmesini
        // "Tükendi" durumuna çeviriyor, bu da kullanıcıya bilgi veriyor.
        if (root.getAttribute('data-block-unavailable') === 'true') {
          if (soldOut) {
            button.setAttribute('data-unavailable', 'true');
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.removeAttribute('data-unavailable');
            button.removeAttribute('aria-disabled');
          }
        }
      });
    });
  }

  function refreshAll() {
    var wrappers = [];

    all(SELECTORS.root).forEach(function (root) {
      var wrapper = root.closest(SELECTORS.wrapper);
      if (wrapper && wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
    });

    wrappers.forEach(function (wrapper) {
      bindWrapper(wrapper);
      all(SELECTORS.root, wrapper).forEach(syncFromNative);
      refreshWrapper(wrapper);
    });
  }

  /* ------------------------------------------------------------------ olaylar */

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    // Sticky sepet barındaki "Değiştir": tema zaten seçiciye kaydırıyor,
    // biz de listeyi açıyoruz ki bar'dan gelen kullanıcı bedeni hemen görsün.
    var stickyChange = event.target.closest(SELECTORS.stickyChangeOption);

    if (stickyChange) {
      // Aynı ürün bloğundaki seçiciyi bul: en yakın ortak atadan yukarı çık.
      var scope = stickyChange.parentElement;
      var stickyRoot = null;

      while (scope && !stickyRoot) {
        stickyRoot = scope.querySelector(SELECTORS.root);
        scope = scope.parentElement;
      }

      // Tema önce seçiciye yumuşak kaydırıyor; liste kaydırma bitince açılıyor.
      if (stickyRoot) {
        window.setTimeout(function () { open(stickyRoot); }, 300);
      }

      return;
    }

    var trigger = event.target.closest(SELECTORS.trigger);

    if (trigger) {
      var triggerRoot = trigger.closest(SELECTORS.root);
      if (!triggerRoot) return;
      event.preventDefault();
      if (isOpen(triggerRoot)) {
        close(triggerRoot);
      } else {
        open(triggerRoot);
      }
      return;
    }

    var option = event.target.closest(SELECTORS.option);

    if (option) {
      var optionRoot = option.closest(SELECTORS.root);
      if (!optionRoot) return;
      event.preventDefault();
      if (option.getAttribute('data-unavailable') === 'true') return;
      selectValue(optionRoot, option);
      close(optionRoot);
      var focusTrigger = optionRoot.querySelector(SELECTORS.trigger);
      if (focusTrigger) focusTrigger.focus();
      return;
    }

    // Dışarı tıklama
    if (!event.target.closest(SELECTORS.root)) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    var root = event.target.closest && event.target.closest(SELECTORS.root);
    if (!root) return;

    var key = event.key;

    if (key === 'Escape' && isOpen(root)) {
      event.preventDefault();
      close(root);
      var trigger = root.querySelector(SELECTORS.trigger);
      if (trigger) trigger.focus();
      return;
    }

    if (key !== 'ArrowDown' && key !== 'ArrowUp' && key !== 'Home' && key !== 'End') return;

    var options = all(SELECTORS.option, root).filter(function (button) {
      return button.getAttribute('data-unavailable') !== 'true';
    });
    if (!options.length) return;

    event.preventDefault();

    if (!isOpen(root)) open(root);

    var current = options.indexOf(document.activeElement);

    if (current === -1) {
      current = options.indexOf(root.querySelector(SELECTORS.option + '.' + CLASSES.selected));
      if (current === -1) current = 0;
      options[current].focus();
      return;
    }

    var next = current;
    if (key === 'ArrowDown') next = Math.min(current + 1, options.length - 1);
    if (key === 'ArrowUp') next = Math.max(current - 1, 0);
    if (key === 'Home') next = 0;
    if (key === 'End') next = options.length - 1;

    options[next].focus();
  });

  /* ------------------------------------------------------------------ bağlama */

  // Dikkat: theme.js'teki OptionButtons (swatch/chip) "change" olayını
  // bubbles:false ile atıyor, yani document üzerinde delegasyon o değişiklikleri
  // kaçırır. Bu yüzden dinleyici her select'e doğrudan bağlanıyor.
  function bindWrapper(wrapper) {
    all(SELECTORS.optionSelect, wrapper).forEach(function (select) {
      if (select.gen78Bound) return;
      select.gen78Bound = true;

      select.addEventListener('change', function () {
        all(SELECTORS.root, wrapper).forEach(syncFromNative);
        refreshWrapper(wrapper);
      });
    });
  }

  /* -------------------------------------------------------------------- kurulum */

  var scheduled = false;

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      refreshAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  // Hızlı görünüm modalı ve tema editörü section'ları sonradan DOM'a giriyor.
  document.addEventListener('shopify:section:load', scheduleRefresh);

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;

        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches(SELECTORS.root) || node.querySelector(SELECTORS.root)) {
            scheduleRefresh();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
